import React, { useEffect } from "react";
import './style/sharedPages.css';
import { useTranslation } from 'react-i18next';

export default function SharedSuccess() {
  const { t } = useTranslation();

  useEffect(() => {
    localStorage.removeItem("sharedFormCompleted");
  }, []);

  return (
    <div className="shared-assessment-page">
      <div className="shared-assessment-container">
        <div className="shared-assessment-form shared-success-card">
          <div className="shared-success-icon">✔</div>
          <h2 className="shared-success-title">{t('success.title')}</h2>
          <p className="shared-success-text">
            {t('success.message')}
          </p>

         
        </div>
      </div>
    </div>
  );
}